<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/empty_card.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<template>
  <div class="bg-white text-sm font-medium text-gray-400 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5c7a2e] cursor-pointer"
    :class="['overflow-hidden shadow-lg text-center h-[10rem] flex place-content-center pt-5', rounded_class]"
  >
    <a v-if="!intermediate_process" href="" @click.prevent="goToNew()" class="p-6 ">
      <i class="text-4xl fa-solid fa-plus"></i>
      <p class="text-lg">{{ $t("labels.new_link") }}</p>
    </a>
    <span v-else class="p-6 ">
      <i class="text-gray-300 text-4xl fa-solid fa-pallet"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Number,
      required: true
    },
    col: {
      type: Number,
      required: true
    },
    rounded_class: {
      type: String,
      default: "",
    },
    intermediate_process: {
      default: false
    }
  },
  components: {},
  computed: {
    agro_exporter_process_id: function () {
      return this.$router.currentRoute._value.params.agro_exporter_process_id;
    },
    container_id: function () {
      return this.$router.currentRoute._value.params.container_id;
    }
  },
  methods: {
    goToNew: function () {
      if (this.intermediate_process) return;
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_new_package_group_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        },
        query: { row: this.row, col: this.col }
      });
    }
  }
};
</script>
